import React from "react";
import PropTypes from "prop-types";
const CopyIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-4-4h24v24H-4z" />
      <path d="M0 0h16v16H0z" />
      <g fill={color || "var(--color-easil-gray-x-dark)"} fillRule="nonzero">
        <path d="M6 2a1 1 0 1 1 0-2h6a4 4 0 0 1 4 4v7a1 1 0 0 1-2 0V4a2 2 0 0 0-2-2H6z" />
        <path d="M3 6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H3zm0-2h6a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3z" />
      </g>
    </g>
  </svg>
);
CopyIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default CopyIcon;
